import React from 'react';
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AboutHero } from "@/components/about/AboutHero";
import { PointOfView } from "@/components/about/PointOfView";
import { WhatWeDoDifferently } from "@/components/about/WhatWeDoDifferently";
import { HowWeOperate } from "@/components/about/HowWeOperate";
import { MissionSection } from "@/components/about/MissionSection";
import { ValuesSection } from "@/components/about/ValuesSection";
import { AboutCTA } from "@/components/about/AboutCTA";

const About = () => {
  return (
    <>
      <div className="min-h-screen bg-background">
        <Navbar />
        <AboutHero />
        <PointOfView />
        <WhatWeDoDifferently />
        <HowWeOperate />
        <MissionSection />
        <ValuesSection />
        <AboutCTA
          title="Ready to Build a System That Actually Converts?"
          description="We'll show you exactly where you're losing leads—and how to fix it."
          primaryButtonText="Get a Free Audit"
          primaryButtonLink="/demo"
        />
      </div>
      <Footer />
    </>
  );
};

export default About;
